<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <jemaat-table />
      </div>
    </div>
    <auth-check></auth-check>
  </div>
</template>

<script>
import JemaatTable from "./components/JemaatTable.vue";
import AuthCheck from '@/components/authCheck.vue'

export default {
  name: "DataJemaat",
  components: {
    JemaatTable, 
    AuthCheck
  },
  data() {
    return {
      stats: {
        titleColor: "opacity-7 text-white",
        descColor: "text-white",
        trip: {
          title: "Today's Trip",
          desc: "145 KM",
          classIcon: "text-dark ni ni-money-coins",
        },
        health: {
          title: "Battery Health",
          desc: "99 %",
          classIcon: "text-dark ni ni-controller ",
        },
        speed: {
          title: "Average Speed",
          desc: "56 Km/h",
          classIcon: "text-dark ni ni-delivery-fast",
        },
        volume: {
          title: "Music Volume",
          desc: "15/100",
          classIcon: "text-dark ni ni-note-03",
        },
      },
    };
  },
};
</script>
